<div class="row row-start">
  <div class="column--12">
    <form [formGroup]="searchForm">
      <mat-card class="mb--md">
        <mat-card-content class="pb--none">
          <div class="row">
            <div class="column--12 column-md--3">
              <mat-form-field class="full-width">
                <mat-label>Courier</mat-label>
                <mat-select formControlName="provider" name="providerItem">
                  <mat-option *ngFor="let providerItem of providerItems" value="{{ providerItem.id }}">{{
                    providerItem.text
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="column--12 column-md--3">
              <mat-form-field class="full-width">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status" name="statusItem">
                  <mat-option *ngFor="let statusItem of statusItems" value="{{ statusItem.id }}">{{
                    statusItem.text
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="column--12 column-md--3">
              <mat-form-field class="full-width">
                <mat-label>Invoice number</mat-label>
                <input matInput formControlName="invoiceNumber" name="invoiceNumber" value="" />
              </mat-form-field>
            </div>
            <div class="column--12 column-md--3">
              <mat-form-field class="full-width">
                <mat-label>Date range</mat-label>
                <mat-date-range-input [formGroup]="range" [rangePicker]="rangePicker">
                  <input matStartDate formControlName="start" placeholder="Start date" />
                  <input matEndDate formControlName="end" placeholder="End date" />
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker></mat-date-range-picker>

                <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="column--12 align-right mb--sm">
              <button
                mat-button
                color="primary"
                type="button"
                (click)="reset()"
                class="mr--md"
                [disabled]="searchForm.invalid || loading"
              >
                Clear all
              </button>
              <button
                mat-flat-button
                color="primary"
                type="submit"
                (click)="search()"
                [disabled]="searchForm.invalid || loading"
              >
                Search
              </button>
            </div>

            <div *ngIf="canUpload" class="row">
              <div class="column--12 align-left mb--sm">
                <button
                  mat-flat-button
                  color="primary"
                  type="submit"
                  (click)="uploadInvoice()"
                  [disabled]="searchForm.invalid || loading"
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </form>
  </div>
</div>

<ng-container *ngIf="!loading; else isLoading">
  <mat-card>
    <mat-card-content>
      <table
        *ngIf="courierInvoices.length > 0; else noInvoices"
        mat-table
        matSort
        [matSortActive]="orderByValue"
        [matSortDirection]="orderByDirection"
        (matSortChange)="sortData($event)"
        [dataSource]="courierInvoices"
      >
        <ng-container matColumnDef="courier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Courier</th>
          <td mat-cell *matCellDef="let element">{{ element.providerName }}</td>
        </ng-container>
        <ng-container matColumnDef="invoice_number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Number</th>
          <td mat-cell *matCellDef="let element">{{ element.invoice_number }}</td>
        </ng-container>

         <ng-container matColumnDef="invoice_amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.status === 'pending'; else amountText">N/A</span>
              <ng-template #amountText>
                <span *ngIf='element.invoice_amount'>{{ element.invoice_amount | currency }}</span>
              </ng-template>
            </td>
          </ng-container>

        <ng-container matColumnDef="file_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>File</th>
          <td mat-cell *matCellDef="let element">
            <button
              *ngIf="element.file_name"
              mat-button
              color="primary"
              (click)="openInvoiceDetail(element)"
            >
              {{ getDisplayFileName(element) }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="rows">
          <th mat-header-cell *matHeaderCellDef>Rows</th>
          <td mat-cell *matCellDef="let element">
            <div class="nobr">
              <span>{{ getRowsCellText(element) }}</span>
              <mat-icon
                *ngIf="getRowsOutcomeTooltipText(element) as rowsTooltip"
                class="icon-info mat-icon-sm ml--xs rows-outcome-icon"
                [ngClass]="getRowsOutcomeIconClass(element)"
                [matTooltip]="rowsTooltip"
                matTooltipPosition="above"
                matTooltipClass="mtx-recon-tooltip multiline-tooltip"
                tabindex="0"
                aria-hidden="false"
                aria-label="Row outcome details"
              ></mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="isTriggerReconVisible(element); else statusText">
              <button
                mat-button
                color='primary'
                class='mdc-small-button text--base align-left'
                (click)="runReconciliation(element)"
              >{{ getStatusLabel(element) }}</button>
            </ng-container>
            <ng-template #statusText>
              <div class="nobr">
                <span [class.text--danger]="element.status === 'processed_with_failures'">{{ getStatusLabel(element) }}</span>
                <mat-icon
                  *ngIf="getStatusTooltipText(element) as statusTooltip"
                  class="icon-info mat-icon-sm text--table-header ml--xs status-info-icon"
                  [matTooltip]="statusTooltip"
                  matTooltipPosition="above"
                  matTooltipClass="mtx-recon-tooltip multiline-tooltip"
                  tabindex="0"
                  aria-hidden="false"
                  aria-label="Status details"
                ></mat-icon>
              </div>
              <app-courier-invoice-retry-button
                [invoice]="element"
                (retried)="onRetried()"
              ></app-courier-invoice-retry-button>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</th>
          <td mat-cell *matCellDef="let element">
            {{ element.updated_at | timeToString : DATE_FORMAT : defaultTimezone }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: displayedColumns"></tr>
      </table>

      <ng-template #noInvoices>
        <div class="row justify-content-center mt--lg">
          <div class="column--12 column-md--4 align-center">
            <img src="{{ CDN_URL }}/admin/images/empty_animated.svg" />
            <p>No invoices found</p>
          </div>
        </div>
      </ng-template>

      <mat-paginator
        (page)="pageChanged($event)"
        [length]="courierInvoicesCount"
        [pageSize]="itemsPerPage"
        [pageSizeOptions]="itemsPerPageOptions"
        [pageIndex]="currentPage"
        [disabled]="courierInvoicesCount <= itemsPerPage"
      >
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-template #isLoading>
  <div class="align-center mt--lg">
    <app-loading></app-loading>
  </div>
</ng-template>
